import { FormConditionalValidation } from '../typings';

export const generateConditionalValidationFieldIds = (
  conditions: FormConditionalValidation[],
): string[] => {
  return conditions.map(condition => condition.relatedFieldId);
};
